export default __webpack_public_path__ + "static/media/amazon-chime.5101b93d.svg";